/**
 * Promise based sleep method that can be chained and does not block the main thread
 * @param ms Sleep time in ms
 */ export async function sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
